export default class PerformanceLevel { }

PerformanceLevel = PerformanceLevel;

PerformanceLevel.LOW = 0;
PerformanceLevel.MEDIUM = 5;
PerformanceLevel.HIGH = 10;

//settings for mapping specific functionalities on performancelevels
//  also taking desired availability of functionalities into account
PerformanceLevel.POPUP_INTRO = 4;
PerformanceLevel.POPUP_OUTRO = 6;